import { MatDialogRef } from '@angular/material';
import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

export interface DialogResponseInput {
  accepted: boolean;
  comment: string;
}

@Component({
  selector: 'app-modal-input-dialog',
  styleUrls: ['./modal-input-dialog.component.scss'],
  templateUrl: './modal-input-dialog.component.html',
})
export class ModalInputDialogComponent {
  public title: string;
  public placeholder: string;
  public comment: string;
  public msgList: string[];
  public commentRequired = false;

  constructor(
    public dialogRef: MatDialogRef<ModalInputDialogComponent>
  ) {}

  close(accepted: boolean) {
    this.dialogRef.close({accepted: accepted, comment: this.comment});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-input-dialog.component.ts